(window.BWFeaturedResource = function ($, Behaviors) {
    "use strict";

    const module = {};

    function BWFeaturedResource() {

    }

    module.BWFeaturedResource = BWFeaturedResource;


    return module;

}(window.jQuery, window.Behaviors));

